import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { colors } from "../../interfaces/colors";

@Component({
  selector: "app-colors",
  templateUrl: "./colors.component.html",
  styleUrls: ["./colors.component.scss"],
})
export class ColorsComponent implements OnInit {
  @Input() selected: string = "";
  @Output() selectedChange: EventEmitter<string> = new EventEmitter<string>();
  searchStr: string = "";
  displayCreate: boolean = false;
  colors = colors;
  filteredColors = colors;

  constructor() {}

  ngOnInit(): void {}

  openCreate() {
    this.displayCreate = true;
  }

  onSearch(event: string) {
    let arr = this.colors;
    if (event?.length > 0) {
      this.filteredColors = arr.filter((x) => {
        if (x.name.includes(event)) {
          return x;
        } else {
          return;
        }
      });
    } else {
      this.filteredColors = this.colors;
    }
  }

  onColorSelection(color: any) {
    this.displayCreate = false;
    this.selectedChange.emit(color.code);
  }
}
